"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Star } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const testimonials = [{
  author: "- Rik De Jong",
  position: "Woningeigenaar",
  quote: "Dankzij de snelle vergelijking hebben we honderden euro's bespaard op onze asbestverwijdering. De offertes waren duidelijk en de specialisten zeer professioneel."
}, {
  author: "- S Maes",
  position: "Particulier",
  quote: "Ik wist niet waar ik moest beginnen met het asbestattest voor mijn woning. Via dit platform kwam ik direct in contact met een erkende keurder in de buurt."
}, {
  author: "- Nathalie Jansens",
  position: "Vastgoedbeheerder",
  quote: "Voor ons renovatieproject hadden we snel een asbestinventaris nodig. Binnen 24 uur hadden we drie scherpe voorstellen. Een absolute aanrader voor elke verbouwer."
}];
function TestimonialCard({
  quote,
  author,
  position
}: {
  quote: string;
  author: string;
  position: string;
}) {
  const initials = author.split(" ").map(n => n[0]).join("").substring(0, 2);
  return <Card className="bg-white border-[#DCDFE0] h-full flex flex-col shadow-none rounded-[4px]">
      <CardContent className="pt-8 flex-grow flex flex-col">
        <div className="flex gap-1 mb-6">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#1AAD4A] text-[#1AAD4A]" />)}
        </div>
        <p className="text-[#182329] not-italic font-sans text-[18px] leading-relaxed flex-grow">{quote}</p>
        <div className="mt-8 flex items-center gap-4">
          <SafeHydrate><Avatar className="h-12 w-12 border border-[#DCDFE0]">
            <AvatarFallback className="bg-[#F8F8F8] text-[#627881] font-sans font-bold">
              {initials}
            </AvatarFallback>
          </Avatar></SafeHydrate>
          <div>
            <p className="font-sans font-bold text-[#182329] text-[18px]">{author}</p>
            <p className="font-sans text-[14px] text-[#627881]">{position}</p>
          </div>
        </div>
      </CardContent>
    </Card>;
}
export default function WatOnzeKlantenZeggen() {
  return <section data-section-id="103432" id="wat-onze-klanten-zeggen" className="bg-[#F8F8F8] text-[#182329] py-24 px-6 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-[#1AAD4A] text-sm font-bold tracking-[0.1em] uppercase font-sans">
            Klantervaringen
          </span>
          <h2 className="font-serif text-[26px] md:text-[26px] font-bold mt-4 text-[#182329]">
            Wat onze klanten zeggen
          </h2>
        </div>

        {}
        <div className="lg:hidden relative px-4 sm:px-12">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i} className="md:basis-1/2">
                  <TestimonialCard {...testimonial} />
                </CarouselItem>)}
            </CarouselContent>
            <div className="hidden sm:block">
              <CarouselPrevious className="bg-white border-[#DCDFE0] text-[#182329] hover:bg-[#F8F8F8] hover:text-[#182329]" />
              <CarouselNext className="bg-white border-[#DCDFE0] text-[#182329] hover:bg-[#F8F8F8] hover:text-[#182329]" />
            </div>
          </Carousel>
        </div>

        {}
        <div className="hidden lg:grid lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, i) => <div key={i} data-index={i} className="h-full">
              <TestimonialCard {...testimonial} />
            </div>)}
        </div>
      </div>
    </section>;
}